import 'react-app-polyfill/ie11';
import 'react-app-polyfill/stable';
import React from 'react';

import dotenv from 'dotenv';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';

import { getConfigCreateStore } from 'redux/store';

import App from './App';
import * as serviceWorker from './serviceWorker';

dotenv.config();

getConfigCreateStore().then(({ store, history, config }) => {
  ReactDOM.render(
    <Provider store={store}>
      <App history={history} config={config} />
    </Provider>,
    document.getElementById('root')
  );
});

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
